import { put, call, takeLatest } from 'redux-saga/effects'

import {
  getDataIntegrations as getDataIntegrationsApi,
  syncDataIntegration as syncDataIntegrationApi,
  getQuickBookConnection as getQuickBookConnectionApi,
  syncExportDataIntegration as syncExportDataIntegrationApi,
} from 'Service/Api'

import * as DataIntegrationTypes from 'Redux/Types/DataIntegrationTypes'
import * as DataIntegrationActions from 'Redux/Actions/DataIntegrationActions'

function* getDataIntegrations() {
  try {
    const { data } = yield call(getDataIntegrationsApi)
    yield put(DataIntegrationActions.getDataIntegrationsSucceeded(data))
  } catch (errors) {
    yield put(DataIntegrationActions.getDataIntegrationsFailed(errors))
  }
}

function* getQuickBookConnection({ payload }) {
  const { params, resolve, reject } = payload
  try {
    const { data } = yield call(getQuickBookConnectionApi, params)
    console.log('The Quickbook URL')
    console.log(data?.url)
    yield put(DataIntegrationActions.getQuickBookConnectionSucceeded(data))
    if (resolve) {
      resolve(data)
    }
  } catch (errors) {
    yield put(DataIntegrationActions.getQuickBookConnectionFailed(errors))
    if (reject) {
      reject(errors)
    }
  }
}

function* syncDataIntegration({ payload }) {
  try {
    yield call(syncDataIntegrationApi)
    yield put(DataIntegrationActions.syncDataIntegrationSucceeded(payload))
  } catch (errors) {
    yield put(DataIntegrationActions.syncDataIntegrationFailed(errors))
  }
}

function* syncDataExport({ payload }) {
  const { syncExportPayload } = payload
  try {
    const { data } = yield call(syncExportDataIntegrationApi, syncExportPayload)
    yield put(DataIntegrationActions.syncExportDataSucceeded(data))
  } catch (errors) {
    yield put(DataIntegrationActions.syncExportDataFailed(errors))
  }
}

export default function* DataIntegrationSaga() {
  yield takeLatest(DataIntegrationTypes.GET_DATA_INTEGRATIONS, getDataIntegrations)
  yield takeLatest(DataIntegrationTypes.GET_QUICKBOOK_CONNECTION, getQuickBookConnection)
  yield takeLatest(DataIntegrationTypes.SYNC_DATA_INTEGRATION, syncDataIntegration)
  yield takeLatest(DataIntegrationTypes.SYNC_EXPORT_DATA, syncDataExport)
}
